import { PRICING_PAGE } from "@/lib/constants";
import { Check, X } from "lucide-react";

function CellContent({ value, isUs }) {
  if (value === "Included") {
    return (
      <div className="flex items-center gap-2 justify-center">
        <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-[#D8FFB8]">
          <Check className="h-3.5 w-3.5 text-[#20611B] stroke-[2.5]" />
        </span>
        <span className="text-sm text-[#20611B] font-medium">{value}</span>
      </div>
    );
  }
  if (isUs) {
    return (
      <div className="flex items-center gap-2 justify-center">
        <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-[#D8FFB8]">
          <Check className="h-3.5 w-3.5 text-[#20611B] stroke-[2.5]" />
        </span>
        <span className="text-sm text-[#20611B] font-medium">{value}</span>
      </div>
    );
  }
  return <span className="text-sm text-[#6B7280]">{value}</span>;
}

export default function CompetitorComparison() {
  const { competitorComparison } = PRICING_PAGE;

  return (
    <section
      data-testid="competitor-comparison-section"
      className="bg-[#F9FAFB] py-12 md:py-20"
      aria-label="Competitor comparison"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
        <div className="text-center mb-10">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-[#1A1A1A] tracking-tight mb-4">
            {competitorComparison.heading}
          </h2>
          <p className="text-[#6B7280] text-base leading-relaxed max-w-2xl mx-auto">
            {competitorComparison.subheading}
          </p>
        </div>

        <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full" data-testid="competitor-table">
              <thead>
                <tr>
                  <th className="text-left text-sm font-semibold text-[#1A1A1A] p-4 md:p-5 bg-gray-50 border-b-2 border-gray-200 w-2/5">
                    Feature
                  </th>
                  <th className="text-center text-sm font-bold text-[#20611B] p-4 md:p-5 bg-[#D8FFB8] border-b-2 border-[#20611B]/20 w-[30%]">
                    {competitorComparison.usLabel}
                  </th>
                  <th className="text-center text-sm font-bold text-red-800 p-4 md:p-5 bg-[#FEE2E2] border-b-2 border-red-200 w-[30%]">
                    {competitorComparison.themLabel}
                  </th>
                </tr>
              </thead>
              <tbody>
                {competitorComparison.rows.map((row, i) => (
                  <tr
                    key={row.feature}
                    data-testid={`competitor-row-${i}`}
                    className={`border-b border-gray-100 last:border-b-0 ${
                      i % 2 === 0 ? "bg-white" : "bg-gray-50/50"
                    }`}
                  >
                    <td className="text-sm text-[#1A1A1A] p-4 md:p-5 font-medium">
                      {row.feature}
                    </td>
                    <td className="text-center p-4 md:p-5 bg-[#D8FFB8]/20">
                      <CellContent value={row.us} isUs={true} />
                    </td>
                    <td className="text-center p-4 md:p-5 bg-[#FEE2E2]/20">
                      <CellContent value={row.them} isUs={false} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}
